var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStat02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 219.06451612903038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-2{stroke:#e8ba3a;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}.cls-4{clip-path:url(#clippath);}.cls-3{stroke:#193c34;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.709677419350555,
    y: 8.129032258064399,
    width: 234.5806451612989,
    height: 203.22580645161543
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "39.578163187110476 200.436398144362101 39.578163187110476 88.25605349333091 24.021661810320438 88.25605349333091 59.808031177110024 42.863368109152361 95.282989653998811 88.217585115891779 80.037891450010648 88.217585115891779 80.037891450010648 121.644833814430967"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.07473884655064,
    y: 185.631797643131,
    width: 78.34493883875439,
    height: 18.303475714281376,
    rx: 4.344229819772528,
    ry: 4.344229819772528
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.07473884655064,
    y: 167.0647370963315,
    width: 78.34493883875439,
    height: 18.30347571428058,
    rx: 4.344229815213895,
    ry: 4.344229815213895
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.07473884655076,
    y: 148.49767654953672,
    width: 78.34493883874961,
    height: 18.303475714274896,
    rx: 4.344229810605159,
    ry: 4.344229810605159
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.07473884655064,
    y: 129.93061600286734,
    width: 78.34493883875439,
    height: 18.303475714279443,
    rx: 4.344229805842587,
    ry: 4.344229805842587
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m122.221140605259279,129.930516863782032c8.267194116200699-19.264468121249593,27.407596808479866-32.757565584250187,49.699481272100456-32.757565584250187,29.855252328310598,0,54.057716312310731,24.202463984000133,54.057716312310731,54.057716312310731,0,29.855252328299684-24.202463984000133,54.057716312299817-54.057716312310731,54.057716312299817-9.221970651260563,0-17.904593760360513-2.309221338040516-25.501174091819848-6.380968778621536"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m135.798136782290385,129.841602718881404c7.31293688705955-12.32371707871971,20.753012606179254-20.584446649219899,36.122485095069351-20.584446649219899,23.18133030925128,0,41.973511522179251,18.79218121292979,41.973511522179251,41.97351152218107,0,23.181330309249461-18.792181212927972,41.973511522170156-41.973511522179251,41.973511522170156-10.031272706170057,0-19.240651625190367-3.518945619531223-26.461039697818705-9.389739799340532"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m146.110727664668957,22.502940948692412s-3.501628455298487,24.720504895549311,26.204596657811635,24.806860035549107c0,0,1.313845809279883-27.830120279619223-26.204596657811635-24.806860035549107Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m199.539839850900535,40.782666519402483s-24.268538618151069-5.865389796839736-27.214533244030463,23.694521964609521c0,0,27.574342596899442,3.987156372299069,27.214533244030463-23.694521964609521Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m142.616682322179258,61.408895500631843s23.45410795962016-8.559765414329377,29.708624284690814,20.480694176028919c0,0-26.950316248790841,7.065567187300985-29.708624284690814-20.480694176028919Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 172.3153243224806,
    y1: 47.30980098424152,
    x2: 172.3153243224806,
    y2: 96.54989936233142
  }), /*#__PURE__*/React.createElement("g", {
    id: "g2779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2781",
    className: "cls-2",
    d: "m160.275130768339295,163.25947943553183h16.931384907191386c3.948325029938133,0,7.149002201089388-3.20067621825001,7.149002201089388-7.149001248189961h0c0-3.948325029930857-3.200677171151256-7.149001248180866-7.149002201089388-7.149001248180866h-7.857181560590107c-3.794698620520649,0-6.87097507271028-3.076276928639345-6.87097507271028-6.870976025609707h0c0-3.794699096979457,3.076275975729004-6.870724457889082,6.87097507271028-6.870724457889082h13.265832487810258"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2785",
    className: "cls-2",
    d: "m172.315349098089428,135.219732621881121v-8.605580310928417"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2789",
    className: "cls-2",
    d: "m172.315349098089428,171.865112156412579v-8.60558031094115"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat02);
export default __webpack_public_path__ + "static/media/stat02.7babd738a04681baaa7f67baf84ebc59.svg";
export { ForwardRef as ReactComponent };